import React from 'react';
import { Text, theme } from 'styles';
import styled from 'styled-components';

export function LineText({ children, ...props }) {
  return (
    <CustomLineText $type="b18" $color="assistive" {...props}>
      {children}
    </CustomLineText>
  );
}

export const CustomLineText = styled(Text)`
  padding-left: 16px;
  position: relative;

  &:before {
    content: '';
    width: 8px;
    height: 100%;
    background-color: ${theme.colors.primary100};
    position: absolute;
    left: 0;
    border-radius: 2px;
  }
`;
